import { render, staticRenderFns } from "./ItemAudit.vue?vue&type=template&id=48ce2560&"
import script from "./ItemAudit.vue?vue&type=script&lang=js&"
export * from "./ItemAudit.vue?vue&type=script&lang=js&"
import style0 from "./ItemAudit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports